export const GA_EVENT_LOGIN_LINKEDIN = "login.linkedIn";
export const GA_EVENT_LOGIN_GOOGLE = "login.google";
export const GA_EVENT_LOGIN_CUSTOM = "login.custom";
export const GA_EVENT_LOGIN_WHATSAPP = "login.whatsapp";
export const GA_EVENT_LOGIN_SMS = "login.sms";

export const GA_EVENT_SIGNUP_LINKEDIN = "signup.linkedIn";
export const GA_EVENT_SIGNUP_GOOGLE = "signup.google";
export const GA_EVENT_SIGNUP_WHATSAPP = "signup.whatsapp";
export const GA_EVENT_SIGNUP_SMS = "signup.sms";
export const GA_EVENT_SIGNUP_FACEBOOK = "signup.facebook";

export const GTM_EVENT_LOGIN_MODAL_OPENED = "login_modal_opened";
export const GTM_EVENT_LINKEDIN_LOGIN_BUTTON_CLICK =
  "linkedin_login_button_clicked";
export const GTM_EVENT_CUSTOM_EMAIL_LOGIN_BUTTON_CLICK =
  "email_login_button_clicked";
export const GTM_EVENT_GOOGLE_LOGIN_BUTTON_CLICK =
  "google_login_button_clicked";
export const GTM_EVENT_WHATSAPP_LOGIN_BUTTON_CLICK =
  "whatsapp_login_button_clicked";
export const GTM_EVENT_SMS_LOGIN_BUTTON_CLICK = "sms_login_button_clicked";
export const GTM_EVENT_PHONE_OPTIONS_BUTTON_CLICK =
  "phone_options_button_clicked";
export const GTM_EVENT_FACEBOOK_LOGIN_BUTTON_CLICK =
  "facebook_login_button_clicked";
export const ACCESS_TOKEN_TIME = 60 * 60 * 1000;
export const REFRESH_TOKEN_TIME = 60 * 60 * 24 * 1 * 7 * 1000;
export const LOGIN_METHODS = {
  GOOGLE: "google",
  LINKEDIN: "linkedin",
  WHATSAPP: "whatsapp",
  SMS: "sms",
  FACEBOOK: "facebook",
};
